import Vue from 'vue';
import Vuex from 'vuex';

const configurations = require.context(
  '.',
  true,
  /^.*\.json$/
);

const state = {};

configurations.keys()
  .map(source => {
    return source.slice(2, -5);
  })
  .forEach(source => {
    import(`./${source}.json`).then(module => {
      state[source] = module;
    })
  });

Vue.use(Vuex);

export default new Vuex.Store({
  state
});
